import React, { useEffect, useRef, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import FTFCSetup from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/FTFCSetup';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CheckBox from '../../../../atomic/formElements/checkBox/CheckBox';
import StyledCheckbox from '../../../../../utils/componentutils/StyledCheckbox';
import { FormControlLabel } from '@material-ui/core';

const setupNames = [
  { label: 'bounce', setup: 'BOUNCE' },
  { label: 'break', setup: 'BREAK' },
  { label: 'break yesterday', setup: 'CANDLE_TRIGGER' },
  { label: 'bounce ema', setup: 'BOUNCE_EMA' },
  { label: 'green takes red', setup: 'BREAK_CANDLE_TYPE' },
  { label: 'red takes green', setup: 'BREAK_CANDLE_TYPE' },
];

export default function SetupOptions({
  top,
  dispatchTop,
  setupFields,
  dispatchSetUpDetails,
}) {
  const lastSetupLabel = useRef('AD_HOC');

  return (
    <>
      {setupNames.map((value, index) => {
        let isSelected = false;
        if (top.setup !== 'BREAK_CANDLE_TYPE') {
          isSelected = top.setup === value.setup;
        } else {
          if (value.label === 'red takes green') {
            if (setupFields.candleColor === 'GREEN') {
              isSelected = true;
            }
          }
          if (value.label === 'green takes red') {
            if (setupFields.candleColor === 'RED') {
              isSelected = true;
            }
          }
        }
        return (
          <Grid item xs={4} key={value.label}>
            <Button
              key={value.label}
              style={{
                fontSize: 10,
                backgroundColor: isSelected ? 'lightgray' : 'white',
                color: isSelected ? 'blue' : 'black',
                height: '100%',
                width: '100%',
              }}
              value={value}
              onClick={(ev) => {
                //console.log(top.setup, value.setup);
                if (lastSetupLabel.current === value.label) {
                  dispatchTop({ setup: 'AD_HOC' });
                  lastSetupLabel.current = 'AD_HOC';
                  return;
                } else {
                  lastSetupLabel.current = value.label;
                }
                dispatchTop({ setup: value.setup });
                if (value.label === 'break yesterday') {
                  dispatchSetUpDetails({
                    timeUnit: 'DAYS',
                    candlesBack: 1,
                    candleDuration: 1,
                  });
                } else if (value.label === 'green takes red') {
                  dispatchSetUpDetails({
                    candleColor: 'RED',
                    candleType: 'LAST',
                    filterForToday: true,
                  });
                } else if (value.label === 'red takes green') {
                  dispatchSetUpDetails({
                    candleColor: 'GREEN',
                    candleType: 'LAST',
                    filterForToday: true,
                  });
                }

                /*dispatchTop({setup: key});
                                if (key === "CANDLE_TRIGGER") {
                                    dispatchSetUpDetails({timeUnit: "DAYS"});
                                } else if (
                                    key === "BREAK_EMA" ||
                                    key === "BOUNCE_EMA"
                                ) {
                                    dispatchSetUpDetails({timeUnit: "MINUTES"});
                                }*/
              }}
            >
              {value.label}
            </Button>
          </Grid>
        );
      })}
      <div className={'m-2'}>
        <Grid item xs={12}>
          {top.setup === 'BOUNCE' || top.setup === 'BREAK' ? (
            <BounceBreakSetup
              top={top}
              setupFields={setupFields}
              dispatchSetUpDetails={dispatchSetUpDetails}
            />
          ) : top.setup === 'CANDLE_TRIGGER' ? (
            <CandleTriggerSetup
              top={top}
              setupFields={setupFields}
              dispatchSetUpDetails={dispatchSetUpDetails}
            />
          ) : top.setup === 'BOUNCE_EMA' ? (
            <EmaSetups
              top={top}
              setupFields={setupFields}
              dispatchSetUpDetails={dispatchSetUpDetails}
            />
          ) : top.setup === 'FTFC' ? (
            <FTFCSetup
              //top={top}
              dispatchSetUpDetails={dispatchSetUpDetails}
              setupDetailTimeFrames={setupFields.timeFrames}
            />
          ) : top.setup === 'BREAK_CANDLE_TYPE' ? (
            <BreakCandleTypeSetup
              top={top}
              dispatchTop={dispatchTop}
              dispatchSetUpDetails={dispatchSetUpDetails}
              setupFields={setupFields}
            />
          ) : null}
        </Grid>
      </div>
    </>
  );
}

function BreakCandleTypeSetup({
  top,
  dispatchTop,
  setupFields,
  dispatchSetUpDetails,
}) {
  const [candleDurationTxt, setCandleDuration] = useState(
    setupFields.candleDuration
  );
  const [breakByTxt, setBreakByTxt] = useState(setupFields.breakBy);

  useEffect(() => {
    setCandleDuration(setupFields.candleDuration);
    setBreakByTxt(setupFields.breakBy);
  }, [setupFields]);

  return (
    <Grid item container>
      <Grid item xs={3}>
        <TextField
          // variant="outlined"
          margin={'none'}
          id="outlined-basic"
          size={'small'}
          label={
            <Typography style={{ fontSize: 10 }}>Candle Duration</Typography>
          }
          value={candleDurationTxt}
          onChange={(ev) => setCandleDuration(ev.target.value)}
          onBlur={(ev) =>
            dispatchSetUpDetails({
              candleDuration: parseInt(ev.target.value),
            })
          }
        />
      </Grid>
      <Grid item xs={1}></Grid>
      <Grid item xs={3}>
        <TextField
          //variant="outlined"
          margin={'none'}
          id="outlined-basic"
          size={'small'}
          label={<Typography style={{ fontSize: 12 }}>break by</Typography>}
          value={breakByTxt}
          onChange={(ev) => setBreakByTxt(ev.target.value)}
          onBlur={(ev) =>
            dispatchSetUpDetails({
              breakBy: parseFloat(ev.target.value),
            })
          }
        />
      </Grid>
      <Grid item xs={1}></Grid>
      <Grid item xs={3}>
        <FormControlLabel
          control={
            <StyledCheckbox
              checked={setupFields.filterForToday}
              onChange={(ev) =>
                dispatchSetUpDetails({
                  filterForToday: ev.target.checked,
                })
              }
              name="filterForToday"
            />
          }
          labelPlacement={'top'}
          size={'small'}
          label={
            <Typography style={{ fontSize: 10 }}>filter for today</Typography>
          }
        />
      </Grid>
      {/*  <Grid item xs={5}>
            <FormControlLabel
                control={
                    <Checkbox
                        color="primary"
                        checked={setupFields.filterForToday}
                        onChange={(ev) =>
                            dispatchSetUpDetails({
                                filterForToday: ev.target.checked,
                            })
                        }
                    />
                }
                label={
                    <Typography style={{fontSize: 10}}>filter for today</Typography>
                }
                labelPlacement="start"
                size="small"
            />
        </Grid>*/}
    </Grid>
  );
}

const BounceBreakSetup = ({ setupFields, dispatchSetUpDetails, top }) => {
  const [price, setPrice] = useState(setupFields.priceToBreak);
  useEffect(() => {
    setPrice(setupFields.priceToBreak);
  }, [setupFields.priceToBreak]);

  return (
    <Grid item xs={4}>
      <TextField
        margin={'none'}
        size={'small'}
        id="outlined-basic"
        label={<Typography style={{ fontSize: 10 }}>Price</Typography>}
        //   variant="outlined"
        style={{ fontSize: 10 }}
        value={price}
        onChange={(ev) => setPrice(ev.target.value)}
        onBlur={(ev) => dispatchSetUpDetails({ priceToBreak: ev.target.value })}
        //    required
      />
    </Grid>
  );
};

const CandleTriggerSetup = ({ setupFields, dispatchSetUpDetails, top }) => {
  const [breakBy, setBreakBy] = useState(setupFields.breakBy);
  useEffect(() => {
    setBreakBy(setupFields.breakBy);
  }, [setupFields.breakBy]);

  return (
    <Grid item xs={2}>
      <TextField
        margin={'none'}
        size={'small'}
        id="outlined-basic"
        label={<Typography style={{ fontSize: 10 }}>breakBy</Typography>}
        //   variant="outlined"
        style={{ fontSize: 10 }}
        value={breakBy}
        onChange={(ev) => setBreakBy(ev.target.value)}
        onBlur={(ev) => dispatchSetUpDetails({ breakBy: ev.target.value })}
        //    required
      />
    </Grid>
  );
};

const EmaSetups = ({ setupFields, dispatchSetUpDetails }) => {
  const [candleDuration, setCandleDuration] = useState(
    setupFields.candleDuration
  );
  const [periodLengths, setPeriodLengths] = useState(setupFields.periodLengths);
  useEffect(() => {
    setCandleDuration(setupFields.candleDuration);
  }, [setupFields.candleDuration]);

  useEffect(() => {
    setPeriodLengths(setupFields.periodLengths);
  }, [setupFields.periodLengths]);

  return (
    <Grid container>
      <Grid item xs={2}>
        <TextField
          margin={'none'}
          size={'small'}
          id="outlined-basic"
          label={
            <Typography style={{ fontSize: 10 }}>candleDuration</Typography>
          }
          //   variant="outlined"
          style={{ fontSize: 10 }}
          value={candleDuration}
          onChange={(ev) => setCandleDuration(ev.target.value)}
          onBlur={(ev) =>
            dispatchSetUpDetails({ candleDuration: ev.target.value })
          }
          //    required
        />
      </Grid>
      <Grid item xs={1}></Grid>
      <Grid item xs={3}>
        <TextField
          margin={'none'}
          size={'small'}
          id="outlined-basic"
          label={<Typography style={{ fontSize: 10 }}>periods</Typography>}
          //   variant="outlined"
          style={{ fontSize: 10 }}
          value={periodLengths}
          onChange={(ev) => setPeriodLengths(ev.target.value)}
          onBlur={(ev) =>
            dispatchSetUpDetails({ periodLengths: ev.target.value })
          }
          //    required
        />
      </Grid>
    </Grid>
  );
};
